import { MessageStatus } from "stream-chat-react";
import { ChatMessageReadStatus } from "Components/Chat/ChatMessageReadStatus";

/**
 * The SDK's message status (sending / sent / delivered / read) with only the read state redrawn:
 * reader avatars instead of one avatar and a count. Everything else, including the rules for
 * which state a message is in, stays the SDK's.
 */
export const ChatMessageStatus = () => (
  <MessageStatus MessageReadStatus={ChatMessageReadStatus} />
);
